<template>
  <v-main>
    <v-card color="green lighten-5 fill-height">
      <v-card-title>
        <v-subheader>{{$t('rec_types.'+item.recType)}}</v-subheader>
        <v-subheader>{{$t('label.for')}}</v-subheader>
        <v-subheader>{{parentName}}</v-subheader>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon color="error">mdi-close-circle</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" :lazy-validation="true">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="item.name"
                :label="$t('field.name')+'*'"
                background-color="yellow lighten-5"
                color="black"
                :placeholder="$t('label.placeholder')"
                clearable
                shaped
                outlined
                :rules="userRules"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-select
                :items="$t('recStatus')"
                :label="$t('field.status')"
                background-color="yellow lighten-5"
                color="black"
                :placeholder="$t('label.placeholder')"
                shaped
                outlined
                v-model="item.status"
                required
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="item.additional"
                background-color="yellow lighten-5"
                color="black"
                :placeholder="$t('label.placeholder')"
                clearable
                shaped
                outlined
                :label="$t('field.additional')"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              {{$t('field.created')+':'}}
              <small>{{item.created}}</small>
            </v-col>
            <v-col cols="6" class="last-modified">
              {{$t('field.modified')+':'}}
              <small>{{item.lastModified}}</small>
            </v-col>
            <v-col cols="12">
              <v-alert
                v-model="showAlert"
                border="left"
                colored-border
                type="error"
                elevation="2"
                :dismissible="true"
                transition="fade-transition"
              >{{alertMessage}}</v-alert>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn
          v-if="$store.getters.test('SubCompanyRecord.d')"
          color="blue darken-1"
          text
          @click="simpleDialog=true"
        >{{$t('button.delete')}}</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-if="$store.getters.test('SubCompanyRecord.w')"
          color="blue darken-1"
          text
          @click="save(false)"
        >{{$t('button.apply')}}</v-btn>
        <v-btn
          v-if="$store.getters.test('SubCompanyRecord.w')"
          color="blue darken-1"
          text
          @click="save(true)"
        >{{$t('button.save')}}</v-btn>
      </v-card-actions>
    </v-card>
    <DeleteDialog v-model="simpleDialog" @click:ok="erase" />
  </v-main>
</template>
<script>
//import axios from "axios";
import app from "@/app.js";
import DeleteDialog from "@/components/DeleteDialog.vue";

export default {
  name: "SubCompanyEditor",
  components: { DeleteDialog },
  props: {
    record: { type: Object, required: true },
    isnew: { type: Boolean },
    value: { type: Boolean },
    parent: { type: String },
  },
  data() {
    return {
      simpleDialog: false,
      showAlert: false,
      alertMessage: "",
      userRules: [(v) => !!v || this.$t("error.required")],
      item: { ...this.record },
    };
  },
  watch: {
    record: {
      handler() {
        console.log(this.item, this.record);
        this.item = { ...this.record };
      },
      deep: true,
    },
  },
  computed: {
    parentName() {
      try {
        return this.$store.getters["struct/companyById"](this.item.fk).text;
      } catch (error) {
        return this.item.fk;
      }
    },
  },
  methods: {
    close() {
      this.$emit("input", false);
    },
    erase() {
      console.log("11");
      /*      app
        .erase(this.item.id, this.item.recType)
        .then(() => {
          this.$emit("delete", this.item);
          this.close();
        })
        .catch(error => {
          this.showAlertMessage(error);
        });*/
    },
    save(close) {
      if (!this.$refs.form.validate()) return;
      let newRec = this.isnew;
      if (this.item.fk_ == "dummy") newRec = false;
      let params = {
        status: this.item.status,
        name: this.item.name,
        additional: this.item.additional,
      };
      if (newRec) params.fk = this.record.fk;
      app
        .update(this.item.id, this.item.recType, params)
        .then(() => {
          if (this.isnew) {
            this.$emit("insert", this.item);
            this.item.fk_ = "dummy";
          } else {
            this.$emit("update", this.item);
          }
          if (close) this.close();
        })
        .catch((error) => {
          this.showAlertMessage(error);
        });
    },
    showAlertMessage(m) {
      if (m.errorMsg) {
        this.alertMessage = this.$t("error." + m.errorMsg);
      } else {
        this.alertMessage = JSON.stringify(m);
      }
      this.showAlert = true;
      setTimeout(() => {
        this.showAlert = false;
      }, 4000);
    },
  },
};
</script>

<style scoped>
.last-modified {
  text-align: right;
}
</style>